import { render, staticRenderFns } from "./SalesDepartmentOverview.vue?vue&type=template&id=6c0f6af0&scoped=true&"
import script from "./SalesDepartmentOverview.vue?vue&type=script&lang=js&"
export * from "./SalesDepartmentOverview.vue?vue&type=script&lang=js&"
import style0 from "./SalesDepartmentOverview.vue?vue&type=style&index=0&id=6c0f6af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f6af0",
  null
  
)

export default component.exports